<style scoped lang="scss" type="text/scss">
    .block-divider-container {
        width: 100%;
        box-sizing: border-box;
        height: 2.5rem;
        padding: 0 1.5rem;
        display: flex;
        align-items: center;
        margin: 1rem 0;
        background: #333;
        border-radius: .15rem;
        font-size: .9rem;
        color: #FFF;
        position: relative;

        &.reversed {
            background: #EEE;
            color: #888;

            .chocolate-bar {
                background-color: #FFF;
            }
        }

        &:first-of-type {
            margin-top: 0;
        }

        .chocolate-bar{
            position: absolute;
            left: .5rem;
            height: 100%;
            width: .1rem;
            background-color: #CCC;
            top: 0;
        }
    }
</style>

<template>
    <div class="block-divider-container" :class="{'reversed': reversed}">
        <section class="chocolate-bar"></section>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            reversed: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {};
        }
    };
</script>
